import moment from "moment";
import React, { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import notify, { ToastType } from "../../Helpers/ToastNotification";
import fileDownload from "js-file-download";
import { fetchAuthToken } from "../../Helpers/Network/OAuthHandler";
import axios from "axios";
import { LoaderContext } from "../../Helpers/Context/Context";
import { DownloadPdfDocData } from "../../Helpers/APIEndPoints/EndPoints";
import { encryptV2 } from "../../Helpers/Cryptography/CryptoV2";

const DownloadDoc = () => {
  const { showLoader, hideLoader, loader } = useContext(LoaderContext);
  const location = useLocation();
  const [Process, setProcess] = useState("Document Is Under Process Please Wait...");

  useEffect(() => {
    if (location.search) {
      const params = new URLSearchParams(location.search);
      if (params.has("docid")) {
        const encLoanId = params.get("docid");
        DownloadFunction(encLoanId);
        
      }
    }
  }, [location.search]);

  const DownloadFunction = async (DocId) => {
    showLoader();
    let requestParams = {
      DocumentId: DocId,
    };
    let token = await fetchAuthToken();
    axios
      .request({
        responseType: "blob",
        method: "POST",
        url: DownloadPdfDocData,
        data: requestParams,
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          "Access-Control-Allow-Headers": "*",
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        setProcess("Please Check Document Downloaded Successfully")
        fileDownload(
          response.data,
          `Documents_` +
            `${moment(new Date()).format(moment.HTML5_FMT.DATE)}` +
            `.pdf`
        );

      })
      .catch((error) => {
        setProcess("Please Retry")
        notify(ToastType.Error, error);
      
      })
      .finally(() => {
        hideLoader(); 
    });
  };

  return <div>{Process && (<p>{Process}</p>)}</div>;
};

export default DownloadDoc;
